import type { FilterOption } from '@/scopes/search/types'
import { useIntl } from '@/intl'
import * as DurationFilterPrimitive from '@/scopes/common/components/Filters/DurationFilterPrimitive'
import { Filter } from '@/scopes/search/components/QuickSearchBar/Filter'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBar/store'
import {
  Button,
  IconGlyph,
} from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function DurationFilterComponent({
  disabled,
  onConfirm,
  options,
  selectedOptions,
  id,
  icon,
  isCollapsed,
}: {
  disabled?: boolean
  onConfirm: (selection: string[]) => void
  options: FilterOption<string>[]
  selectedOptions: FilterOption<string>[]
  id: string
  icon?: IconGlyph
  isCollapsed?: boolean
}) {
  const intl = useIntl()
  const { setActiveItem } = useQuickSearchStore()
  const [localSelectedValues, setLocalSelectedValues] = React.useState(selectedOptions.map(option => option.value))
  const onSelectedValueChange2 = (newSelectedValue: string[]) => {
    setLocalSelectedValues(newSelectedValue)
  }

  React.useEffect(() => {
    setLocalSelectedValues(selectedOptions.map(option => option.value))
  }, [selectedOptions])

  const handleConfirm = () => {
    setActiveItem(null)
    onConfirm(localSelectedValues)
  }

  const formattedSelectedValuesCompact = selectedOptions.length ? selectedOptions[0].name : undefined

  return (
    <Filter
      id={id}
      icon={icon}
      placeholder={intl.formatMessage({
        id: 'quicksearch_filter_travel_duration_placeholder',
      })}
      title={intl.formatMessage({
        id: 'quicksearch_filter_travel_duration_title',
      })}
      onConfirm={handleConfirm}
      selectionFormattedText={formattedSelectedValuesCompact}
      isCollapsed={isCollapsed}
    >
      <DurationFilterPrimitive.Root
        options={options}
        selectedValues={localSelectedValues}
        onSelectedValueChange={onSelectedValueChange2}
      />
      <DurationFilterPrimitive.Footer>
        <Button onClick={handleConfirm} disabled={disabled} $fullWidth>
          {intl.formatMessage({ id: 'quicksearch_save_button_text' })}
        </Button>
      </DurationFilterPrimitive.Footer>
    </Filter>
  )
}
